import { render } from "./AddPriceGroup.vue?vue&type=template&id=5fd64780&ts=true"
import script from "./AddPriceGroup.vue?vue&type=script&lang=ts"
export * from "./AddPriceGroup.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__